import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "ion-padding-start"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "horizontal-scroll" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { style: {"max-height":"200px","overflow-y":"scroll"} }
const _hoisted_12 = { style: {"max-height":"200px","overflow-y":"scroll"} }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { style: {"padding-left":"16px"} }, {
              default: _withCtx(() => [
                (_ctx.isStudentView)
                  ? (_openBlock(), _createBlock(_component_ion_label, {
                      key: 0,
                      class: "ion-text-wrap"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("h2", null, "Details", -1)
                      ])),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_ion_label, {
                      key: 1,
                      class: "ion-text-wrap"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, [
                          _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.user.class) + _toDisplayString(_ctx.formatStudentNumber(_ctx.user.studentNumber)), 513), [
                            [_vShow, _ctx.user.class]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.user.fullName) + " ", 1),
                          (_ctx.user.chineseName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(" + _toDisplayString(_ctx.user.chineseName) + ")", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.user.schoolId?.toUpperCase()) + " (" + _toDisplayString(_ctx.getSchoolObj('name')) + ")", 1)
                        ])
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }),
            (!_ctx.isStudentView)
              ? (_openBlock(), _createBlock(_component_ion_buttons, {
                  key: 0,
                  slot: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      color: _ctx.user.userInWaGroup ? 'success' : 'danger',
                      slot: "icon-only",
                      target: "_blank",
                      href: _ctx.user.waGroupLink
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.logoWhatsapp }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["color", "href"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { fixed: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "5",
                      class: "ion-text-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _ctx.getAppSheetFileLink('user', _ctx.user.profilePic)
                        }, null, 8, _hoisted_2),
                        (!_ctx.isStudentView)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createVNode(_component_ion_chip, { class: "small-chip" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.user.preferredName || _ctx.user.fullName), 1)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, { size: "7" }, {
                      default: _withCtx(() => [
                        (_ctx.isStudentView)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _cache[8] || (_cache[8] = _createTextVNode("Full name: ")),
                                      _createElementVNode("b", null, _toDisplayString(_ctx.user.fullName), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_ctx.user.preferredName)
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _cache[9] || (_cache[9] = _createTextVNode("Preferred name: ")),
                                          _createElementVNode("b", null, _toDisplayString(_ctx.user.preferredName), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.user.chineseName)
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _cache[10] || (_cache[10] = _createTextVNode("Chinese name: ")),
                                          _createElementVNode("b", null, _toDisplayString(_ctx.user.chineseName), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _cache[11] || (_cache[11] = _createTextVNode("School: ")),
                                      _createElementVNode("b", null, _toDisplayString(_ctx.user.schoolId?.toUpperCase()), 1),
                                      _createTextVNode(" (" + _toDisplayString(_ctx.getSchoolObj('name')) + ")", 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _cache[12] || (_cache[12] = _createTextVNode("School district: ")),
                                      _createElementVNode("b", null, _toDisplayString(_ctx.getSchoolObj('district')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _cache[13] || (_cache[13] = _createTextVNode("School banding: ")),
                                      _createElementVNode("b", null, _toDisplayString(_ctx.getSchoolObj('band')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_ctx.user.roles == 'secondary-school-student')
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _cache[14] || (_cache[14] = _createTextVNode("Rank in form: ")),
                                          _createElementVNode("b", null, _toDisplayString(_ctx.user.rankInForm), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(Array.isArray(_ctx.user.studyingElectives) ? _ctx.user.studyingElectives.join(" , ") : _ctx.user.studyingElectives), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_ctx.user.roles == 'secondary-school-student')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createVNode(_component_ion_badge, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.user.yearDSE) + " DSE", 1)
                                      ]),
                                      _: 1
                                    }),
                                    _cache[16] || (_cache[16] = _createTextVNode("  ")),
                                    (_ctx.user.secondarySchoolStudent?.group == 'ucircle')
                                      ? (_openBlock(), _createBlock(_component_ion_badge, { key: 0 }, {
                                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                                            _createTextVNode(" UCircle ")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])),
                        (_ctx.user.roles == 'teacher')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _cache[17] || (_cache[17] = _createTextVNode("School roles: ")),
                                      _createElementVNode("b", null, _toDisplayString(_ctx.user.teacher?.schoolRoles), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("small", {
                                        innerHTML: (_ctx.user.teacher?.classRoles || []).filter(cr => cr.status != 'removed').map(cr => (`<b>${cr.role} (${cr.classes})</b>`)).join(' & ')
                                      }, null, 8, _hoisted_8)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _cache[18] || (_cache[18] = _createTextVNode("Email: ")),
                                      _createElementVNode("b", null, _toDisplayString(_ctx.user.email), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _cache[19] || (_cache[19] = _createTextVNode("Phone: ")),
                                      _createElementVNode("b", null, _toDisplayString(_ctx.user.phone), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.user.firstSelectedDisciplineNames && !_ctx.isStudentView)
              ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, { color: "primary" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createElementVNode("b", null, "Interested disciplines", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.firstSelectedDisciplineNames.split(' , '), (d) => {
                        return (_openBlock(), _createBlock(_component_ion_chip, {
                          class: "small-chip",
                          key: d
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(d), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.currUser.teacher || _ctx.currUser.isAdmin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_ctx.user.userPrograms && _ctx.user.userPrograms.length > 0)
                    ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            color: "primary",
                            button: "",
                            detail: "",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openAchieveJUPASResultPageModal(_ctx.user)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createElementVNode("b", null, "AchieveJUPAS", -1)
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.userPrograms, (up, idx) => {
                              return (_openBlock(), _createBlock(_component_ion_item, { key: idx }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.getBandLabel(up.order-1)) + ".", 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.getProgramObj(up.programId, 'displayName')), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.userProfessions && _ctx.user.userProfessions.length > 0 && !_ctx.isStudentView)
              ? (_openBlock(), _createBlock(_component_ion_card, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, { color: "primary" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createElementVNode("b", null, "Target professions", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.userProfessions, (up, idx) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: idx,
                          onClick: ($event: any) => (_ctx.openProfessionModal(up.professionId)),
                          button: "",
                          detail: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(idx+1) + ". " + _toDisplayString(_ctx.getProfessionName(up.professionId)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.user.roles != 'teacher' && !_ctx.hideCommentSection)
      ? (_openBlock(), _createBlock(_component_ion_footer, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  color: "fdmtred",
                  lines: "full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => [
                        (_ctx.isStudentView)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Vote for this student?"))
                          : (_openBlock(), _createElementBlock("p", _hoisted_14, "Is this student shortlisted?"))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_chip, {
                      style: {"--color":"#fff","--background":"var(--ion-color-primary)","border-color":"#999"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateUserReaction('dislike'))),
                      outline: _ctx.userUser.reaction != 'dislike'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                            _createTextVNode("No")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["outline"]),
                    _createVNode(_component_ion_chip, {
                      style: {"--color":"#fff","--background":"var(--ion-color-primary)","border-color":"#999"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateUserReaction('like'))),
                      outline: _ctx.userUser.reaction != 'like'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_text, null, {
                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createTextVNode("Yes")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["outline"])
                  ]),
                  _: 1
                }),
                (!_ctx.isStudentView)
                  ? (_openBlock(), _createBlock(_component_ion_item, {
                      key: 0,
                      color: "fdmtred",
                      lines: "full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select, {
                          label: "Your grading",
                          placeholder: "Please select",
                          style: {"min-height":"32px"},
                          modelValue: _ctx.userUser.grade,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userUser.grade) = $event)),
                          onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateUserGrade(_ctx.userUser.grade)))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Excellent','Very good','Good','Fair','Below average'], (grade) => {
                              return _createVNode(_component_ion_select_option, {
                                key: grade,
                                value: grade
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(grade), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_textarea, {
                  modelValue: _ctx.userUser.reason,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userUser.reason) = $event)),
                  "label-placement": "floating",
                  label: "Any comments / remarks?",
                  style: {"margin-top":"5px"},
                  fill: "outline",
                  rows: 5
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}